module.exports = __webpack_public_path__ + "static/img/07.04cd8c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/07.jpg
// module id = eDfx
// module chunks = 0